import type { RouteLocationNormalized } from 'vue-router'
import type { Grant, GrantRequirements, GrantType } from '~/types/Security'

export type GrantCheck = {
  grant: Grant
  type: GrantType
}
export const useCheckGrants = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  grants: GrantCheck[],
  requirements: GrantRequirements = 'ALL') => {
  const securityStore = useSecurityStore()
  if (requirements === 'ALL') {
    for (const value of grants) {
      if (!securityStore.permissions[value.grant][value.type]()) {
        return showError({ status: 403, fatal: true, statusMessage: 'Unauthorized' })
      }
    }
    return true
  } else if (requirements === 'ANY') {
    for (const value of grants) {
      if (securityStore.permissions[value.grant][value.type]()) {
        return true
      }
    }
  }
  return showError({ status: 403, fatal: true, statusMessage: 'Unauthorized' })
}
